var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3002 41.4034C42.3847 36.3819 37.7156 32.6156 32.1909 30.8287C34.8376 29.2539 36.8941 26.8537 38.0446 23.9968C39.1951 21.14 39.3759 17.9844 38.5593 15.0148C37.7426 12.0453 35.9737 9.42589 33.5242 7.55905C31.0746 5.69222 28.08 4.68115 25.0001 4.68115C21.9203 4.68115 18.9257 5.69222 16.4761 7.55905C14.0266 9.42589 12.2577 12.0453 11.441 15.0148C10.6244 17.9844 10.8052 21.14 11.9557 23.9968C13.1061 26.8537 15.1627 29.2539 17.8094 30.8287C12.2848 32.6155 7.61585 36.3817 4.70031 41.403C4.56289 41.6405 4.49043 41.91 4.49023 42.1844C4.49004 42.4588 4.56211 42.7285 4.6992 42.9662C4.83628 43.2039 5.03355 43.4013 5.27116 43.5385C5.50876 43.6758 5.77832 43.748 6.05272 43.748L43.9478 43.7484C44.2222 43.7484 44.4918 43.6762 44.7294 43.5389C44.967 43.4017 45.1643 43.2043 45.3014 42.9666C45.4385 42.7289 45.5106 42.4592 45.5104 42.1848C45.5102 41.9104 45.4377 41.6409 45.3002 41.4034L45.3002 41.4034Z",
    fill: "#1A6751"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.b292de449a741703954e5cdee239f854.svg";
export { ForwardRef as ReactComponent };